import React, { useState, useEffect } from "react";
import { LoginButton } from "./ProfileElements";
import { Paper } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Formik, Field, Form } from "formik";
import axios from "../../../axios";
import { FILE_UPLOAD_API_URL } from "../../../constants/Statics";
import {axios as axios2} from "axios";
import Overlay from "../../../components/Overlay";
import { toast } from "react-toastify";
import { connect } from "react-redux";
import Cookies from "js-cookie";
import * as actionTypes from "../../../store/actions";
import { Link, useNavigate } from "react-router-dom";
import { profileValidator } from "../../../utils/validators";
import Avatar from "@mui/material/Avatar";
import dummyProfile from "../../../assets/images/lady.png";
import "./profile.css";
import coreAxios from 'axios'; // core Axios
import Input from "../../../components/Input";
import InputLogin from "../../../components/InputLogin";
import { extractDate, uploadImage, subadminAccessChange } from "../../../utils/functions";


// icons
import { MdOutlinePhotoCamera } from "react-icons/md";
import { decryptResponse } from "../../../utils/crypto";
import { FaArrowLeft } from "react-icons/fa";

import {
  DashboardContainer,
  DashboardWrapper,
  DashboardHeading,
  DashHeading,
  MenuAndBack,
  ProfileDetailForm,
  InputDivide,
} from "./ProfileElements";


const useStyles = makeStyles((theme) => ({
  textMiddle: {
    verticalAlign: "middle !important",
    textAlign: "center",
  },
  tablePadding: {
    padding: "0.5rem",
    textAlign: "center",
    fontSize: "0.8rem",
  },
  tablePaginationStyle: {
    border: "1px solid #0000001a",
    borderRadius: "0rem 0rem 0.4rem 0.4rem",
    overflowY: "hidden",
  },
  tableFlex: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
}));

const ProfileManagement = ({ setUsers, userData }) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const accessToken = sessionStorage.getItem("token") || localStorage.getItem("token");
  const adminData = JSON.parse(sessionStorage.getItem("userData") || localStorage.getItem("userData"));
  const [profileImage, setProfileImage] = useState(adminData?.profileImage || "");

  const [profileUpdate, setProfileUpdate] = useState({
    firstName: userData?.firstName || adminData?.firstName || "",
    lastName: userData?.lastName || adminData?.firstName || "",
    email: userData?.email || adminData?.firstName || "",
  });

  const updateProfile = async (values) => {
    setIsLoading(true);

    var fromData = {
      firstName: values.firstName,
      lastName: values.lastName,
      email: values.email,
      profileImage: profileImage,
    };

    try {
      const { data } = await axios.put(`/private/updateProfile`, fromData, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
console.log("jef",data)
      setProfileUpdate(data.data);
      setUsers(data.data);
      localStorage.setItem("userData", JSON.stringify(data.data));
      toast.success(`${data.message}`, {
        position: "top-right",
      });
    } catch (error) {
      if (error.response.status == 422) {
        toast.error(error.response.data?.errors[0]?.msg, {
          position: "top-right",
        });
      } else if (error?.response?.status === 419) {
        localStorage.clear();
        Cookies.remove("showProfileSidebar");
        setUsers("");

        toast.error(`${error.response.data?.message}`, {
          position: "top-right",
        });

        navigate("/");
      } else {
        toast.error(`${error.response.data?.message}`, {
          position: "top-right",
        });
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleProfileImage = async (event) => {
    let password = "e0m636izi4gnbz9htaxewtr5ogepbwai"
    const file = event.target.files[0];

    // Validate file type
    if (!file.type.startsWith('image/')) {
      toast.error("Please upload a valid image file", {
        position: "top-right",
      });
      return;
    }
  
    const formData = new FormData();
    formData.append("file", file);

    console.log("formData",file)

    setIsLoading(true);

    try {
      const response = await coreAxios.post(`${FILE_UPLOAD_API_URL}/api/fileUpload`, formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          }
        }
      );
 
      let data = await decryptResponse(response.data, password); 
      if (typeof data === "string") {

        data = JSON.parse(data);
      }
      
      setProfileImage(data?.data?.imageUrl);
      // toast.success(data?.message, {
      //   position: "top-right",
      // });
    } catch (error) {
      toast.error("Failed to update profile image", {
        position: "top-right",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <DashboardContainer>
        <DashboardWrapper style={{marginTop:"1rem"}}>
          <ProfileDetailForm>
            <div className="common-heading">Profile Settings</div>

            <Formik
              enableReinitialize
              initialValues={profileUpdate}
              validate={profileValidator}
              validateOnChange
              onSubmit={(values) => updateProfile(values)}
            >
              {(formikBag) => {
                return (
                  <Form className="profile-form">
                    <div className="d-flex align-items-center mb-4">
                      <div className="profile-show me-4">
                        <input
                          type="file"
                          id="avatar-upload"
                          accept="image/*"
                          style={{ display: "none" }}
                          onChange={(e) => handleProfileImage(e)}
                        />
                        <Avatar
                          alt="profile"
                          src={profileImage ? profileImage : dummyProfile}
                          sx={{ width: 130, height:130 }}
                        />
                        <div className="profile-change-icon" onClick={() => document.getElementById("avatar-upload").click()}>
                          <MdOutlinePhotoCamera style={{ color:"#ffffff", fontSize:"1.2rem" }}/>
                        </div>
                      </div>
                    </div>

                    <div>
                      <InputDivide>
                        <div className="col-md-4">
                          <label className="mb-2">First Name</label>
                          <Field name="firstName w-100">
                            {({ field }) => (
                              <Input
                                {...field}
                                type="text"
                                style={{
                                  background: formikBag.values.firstName ? "#FFFFFF" : "#FFFFFF",
                                }}
                                value={formikBag.values.firstName}
                                onChange={(e) => {
                                  formikBag.setFieldValue(
                                    "firstName",
                                    e.target.value
                                  );
                                }}
                                error={
                                  formikBag.touched.firstName &&
                                  formikBag.errors.firstName
                                    ? formikBag.errors.firstName
                                    : null
                                }
                                className="form-control"
                                placeholder="Enter First Name"
                              />
                            )}
                          </Field>
                        </div>
                        <div className="col-md-4">
                          <label className="mb-2">Last Name</label>
                          <Field name="lastName">
                            {({ field }) => (
                              <Input
                                {...field}
                                type="text"
                                style={{
                                  background: formikBag.values.lastName ? "#FFFFFF" : "#FFFFFF",
                                }}
                                value={formikBag.values.lastName}
                                onChange={(e) => {
                                  formikBag.setFieldValue(
                                    "lastName",
                                    e.target.value
                                  );
                                }}
                                error={
                                  formikBag.touched.lastName &&
                                  formikBag.errors.lastName
                                    ? formikBag.errors.lastName
                                    : null
                                }
                                className="form-control"
                                placeholder="Enter Last Name"
                              />
                            )}
                          </Field>
                        </div>
                      </InputDivide>
                      <InputDivide className="mt-3">
                        <div className="col-md-4">
                          <label className="mb-2">Email ID</label>
                          <Field name="email">
                            {({ field }) => (
                              <Input
                                {...field}
                                type="email"
                                style={{
                                  background: formikBag.values.email ? "lightgray" : "#FFFFFF",
                                }}
                                value={formikBag.values.email}
                                onChange={(e) => {
                                  formikBag.setFieldValue(
                                    "email",
                                    e.target.value
                                  );
                                }}
                                error={
                                  formikBag.touched.email &&
                                  formikBag.errors.email
                                    ? formikBag.errors.email
                                    : null
                                }
                                className="form-control"
                                placeholder="Enter Your Email"
                                readOnly={true}
                              />
                            )}
                          </Field>
                        </div>
                      </InputDivide>

                      <InputDivide className="mt-5">
                        <div>
                          <LoginButton
                            type="submit"
                            className="buttonWidthResponsive"
                          >
                            Save Changes
                          </LoginButton>
                        </div>
                      </InputDivide>
                    </div>
                  </Form>
                );
              }}
            </Formik>
          </ProfileDetailForm>
        </DashboardWrapper>
      </DashboardContainer>

      {isLoading && <Overlay />}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    userData: state.userData,
    locationData: state.locations,
    defaultState: state.defaultState,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setUsers: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_USER,
        updatedUser: updatedValue,
      });
    },
    setDefaultState: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_DEFAULT,
        updateDefault: updatedValue,
      });
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProfileManagement);
